import { render } from "./ReportsSales.vue?vue&type=template&id=b68749a8"
import script from "./ReportsSales.vue?vue&type=script&lang=js"
export * from "./ReportsSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__